import React from "react";
import styles from "./news.module.css";
import { Container } from "react-bootstrap";
import { IoIosShareAlt } from "react-icons/io";
import Navbar from "../../Components/Navbar/Navbar";
import { Heading } from "../../Components/TextComponents/TextComponents";
import RecentNews from "../../Components/RecentNews/RecentNews";

const Details = () => {
  return (
    <React.Fragment>
      <div className={styles.details_sec}>
        <Navbar />
        <Container fluid>
          <div className={styles.section}>
            <h6>
              India’s Push Toward Renewable Energy: What It Means for Global
              Trade
            </h6>
            <p>
              India's ambitious plan to achieve 500 GW of non-fossil energy
              capacity by 2030 is reshaping the energy market. Here's how
              businesses can align with this monumental shift.
            </p>
            <p>
              India's ambitious plan to achieve 500 GW of non-fossil energy
              capacity by 2030
            </p>

            <div className={styles.btn_section}>
              <button>5 min read</button>
              <button>
                <IoIosShareAlt className="text-white" /> Share this
              </button>
            </div>
          </div>
        </Container>
      </div>
      <Container>
        <div className={styles.news_section}>
          <img src="/images/news/image_2.png" alt="farming" />
          <Heading>
            India’s Renewable Energy Revolution and Its Global Trade Impacts
          </Heading>
          <p>
            India is rapidly transforming its energy sector, positioning itself
            as a global leader in renewable energy. With an ambitious target of
            achieving 500 GW of non-fossil fuel capacity by 2030, the country is
            paving the way for a cleaner, greener future. This bold vision is
            not just a response to global climate challenges but also an effort
            to redefine its economic role on the world stage. As India
            intensifies its focus on renewable energy, opportunities for global
            trade and innovation are flourishing.
            <br />
            <br />
            At the heart of India’s renewable energy push is its commitment to
            scaling up solar, wind, and hydropower projects. States like
            Gujarat, Rajasthan, and Tamil Nadu are leading the charge, housing
            some of the largest solar farms in the world. Additionally, the
            recently launched Green Hydrogen Mission aims to establish India as
            a hub for hydrogen production, further diversifying its energy mix.
            These initiatives not only promise to reduce the country’s carbon
            footprint but also bolster energy security, a critical factor for a
            growing economy.
            <br />
            <br />
            This renewable energy transformation is reshaping global trade
            dynamics. India’s advancements in solar and wind technologies have
            created a vibrant export market for cost-effective and scalable
            solutions. Additionally, its surplus renewable energy has the
            potential to be shared with neighboring countries, opening avenues
            for energy-as-a-service trade. On the supply chain front, increased
            demand for rare earth materials, solar panels, and energy storage
            solutions is fostering new collaborations between domestic and
            international players.
            <br />
            <br />
            However, the transition is not without its challenges. Businesses
            must navigate evolving energy regulations and contend with
            intensifying competition in renewable sectors. At the same time,
            there are significant opportunities for companies to align their
            strategies with India’s energy goals. Investing in renewable
            solutions, integrating sustainable practices, and leveraging
            government incentives are just some ways businesses can participate
            in this transformation.
            <br />
            <br />
            India’s renewable energy journey is more than a domestic
            initiative—it’s a call to action for global players to innovate,
            invest, and collaborate. By aligning with India’s vision, businesses
            can help shape a sustainable future while unlocking new trade
            opportunities. As the energy landscape evolves, partnerships and
            innovative approaches will be key to maximizing the benefits of this
            revolution. Crossborder BTC is proud to support businesses in
            navigating India’s dynamic renewable energy market. By offering
            expertise and solutions tailored to the unique demands of this
            transition, we help companies seize opportunities in one of the most
            exciting energy transformations of our time. Together, we can power
            the future, one sustainable step at a time.
          </p>
        </div>
      </Container>
      <RecentNews/>
    </React.Fragment>
  );
};

export default Details;
